import React from 'react';
import { Redirect } from 'react-router-dom';
import { useTranslate } from 'core/translate';
import FeaturesCompare from '../featuresCompare/FeaturesCompare';

const getHeaderDataForStyle = style => {
  if (!style) {
    return null;
  }
  return {
    primaryText: style.trimName,
    secondaryText: style.driveType,
    tertiaryText: style.bodyTypeName,
    msrp: style.msrp,
    imageUrl: style.image
  };
};

const TrimCompare = props => {
  const translate = useTranslate();
  const {
    match,
    location,
    features,
    disclaimer,
    lockDefaultColumn,
    config,
    onSelect,
    onSectionsChange
  } = props;
  const { groups, styleIds: valuesByStyle, options } = features;

  const searchParams = new URLSearchParams(location.search);

  if (!searchParams.has('styleOne')) {
    searchParams.set('styleOne', config.styleId);
    return <Redirect to={`${match.url}?${searchParams.toString()}`} />;
  }

  const styleOne = searchParams.get('styleOne');
  const styleTwo = searchParams.get('styleTwo');
  const styleThree = searchParams.get('styleThree');
  const sections = searchParams.getAll('section');

  const infoByStyle = options.reduce((hash, option) => {
    hash[option.styleId] = option;
    return hash;
  }, {});

  const styles = [styleOne, styleTwo, styleThree];
  const headers = styles.map(x => getHeaderDataForStyle(infoByStyle[x]));
  const columns = styles.map(x => valuesByStyle[x]);

  return (
    <FeaturesCompare
      featureGroups={groups}
      columns={columns}
      headers={headers}
      defaultSections={sections}
      lockDefaultColumn={lockDefaultColumn}
      disclaimer={disclaimer}
      placeholderText={translate('component.trim.compare.add.trim')}
      analyticsKey="compare trims"
      onSelect={onSelect}
      onSectionsChange={onSectionsChange}
    />
  );
};

export default TrimCompare;
